import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ResponseStatus } from "../../actions/types";
import allUsersService from "../../services/all-users.service";
import { User } from "../../pages/shared/models/user/user";
import { handleGetCurrentUser } from "../reducers/current-user.reducer";

export const getCurrentUserData = createAsyncThunk(
  "getCurrentUserData",
  async (props, thunkApi) => {
    try {
      const user = await allUsersService.getCurrentUser();
      return { currentUser: user && user.data };
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const currentUserSlice = createSlice({
  name: "currentUser",
  initialState: {
    currentUser: undefined,
    errors: [],
    isLoading: false,
  } as CurrentUserSliceData,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCurrentUserData.pending, (state) =>
      handleGetCurrentUser(state, ResponseStatus.PENDING, null),
    );
    builder.addCase(getCurrentUserData.fulfilled, (state, action) =>
      handleGetCurrentUser(state, ResponseStatus.SUCCESS, action.payload),
    );
    builder.addCase(getCurrentUserData.rejected, (state, action) =>
      handleGetCurrentUser(state, ResponseStatus.FAIL, action.payload),
    );
  },
});

export interface CurrentUserSliceData {
  currentUser: User | undefined;
  errors: any[];
  isLoading: boolean;
}

export default currentUserSlice.reducer;
